import(/* webpackMode: "eager" */ "/app/app/assets/scss/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/app/assets/scss/theme.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.jsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/simplebar-react/dist/simplebar.min.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/flatpickr/dist/themes/light.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/provider/auth.provider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/provider/providers.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/provider/providers.jsx");
